import WithSidebar from "../../../layouts/WithSidebar"
import { ajax } from "../../../scripts/helper"
import utils from "../../../scripts/utils"
import { useSnackbar } from 'notistack'
import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import CashForm from "../../../components/Cash-form"


const CashPayment = () => {
    const [searchParams, setSearchParams] = useSearchParams()

    const id = searchParams.get("id")




    return(
        <WithSidebar pageTitle={'Create Cash Payment'} breadcrumb={'Dashboard > Payment > CASH'}>
            <CashForm edit={(id ? id: null)}/>
        </WithSidebar>
    )
}

export default CashPayment